export const createUuid = () => {
    const randomUint32 = window.crypto.getRandomValues(new Uint32Array(1))[0];
    return randomUint32.toString(16);
};
//# sourceMappingURL=createUuid.js.map